<div class="item othercomment">
  <div class="header">
    <span class="user bold"> {{ commentItem.createdByUserName }} </span>
    <span class="timestamp">• {{ commentItem.createdDate | date:"MM/dd/yyyy hh:mm a" }}</span>
    <span *ngIf="commentItem.hasType"> • {{ commentItem.commentType }}</span>
  </div>
  <div class="othercomment-body" innerHTML="{{commentItem.commentText}}" ></div>
</div>
